module.exports = __webpack_public_path__ + "img/bmcl_main0.32d94f7e.jpg";